import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Row, Col, Button, FormGroup, Tabs, Tab, FormControl, Table, Modal, Label } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import UsersService from "../../services/users-service";
import ActivityLogsService from "../../services/activity-service";
import './style.css';

class Widgets extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            show: false,
            data: null,
            storedCredenials: UsersService.sharedInstance.getStoredCredentials(),
        }
    }

    render(){
        return(
            <Row className="dispatch-comm">
                <Col className="" xs={4} md={4} >
                    <div className="card empty-widget">
                        {/* <div className="card-header">
                                <FontAwesomeIcon className="card-header-icon" icon="phone"/>
                                <h5>DISPATCH</h5>
                        </div>

                        <div className="card-content">
                            <Button className="call-dispatch red-btn">CALL DISPATCH</Button>
                        </div> */}
                    </div>
                </Col>
                <Col className="content-section" xs={8} md={8}>
                    <div className="card empty-widget">
                        {/* <div className="card-header">
                            <FontAwesomeIcon className="card-header-icon" icon="comment-alt"/><h5>COMM LOG</h5>
                        </div>
                        <div className="card-content">
                            <form>
                                <FormGroup controlId="formBasicText">
                                <FormControl
                                    type="text"
                                    placeholder="Enter text"
                                />
                                </FormGroup>
                            </form>
                            <Button className="comm-log-btn green-btn">ADD ENTRY</Button>
                        </div> */}
                    </div>
                </Col>
            </Row>
        )
    }
}

export default Widgets;